import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterCompanyId'
})
export class FilterCompanyIdPipe implements PipeTransform {

    transform(list: any[], companyId): any[] {
        return list.filter(item => item.t_company_id == companyId);
    }

}


// WEBPACK FOOTER //
// ./src/app/pipes/filter-company-id.pipe.ts